import { Popover } from "@chakra-ui/react";
import { useStyles } from "../../hooks/useStyles";
import React from "react";

interface Props {
  open?: boolean;
  setOpen?: (open: boolean) => void;
  onClose?: () => void;
  placement?: "bottom-end" | "bottom-start" | "top-end" | "top-start";
  trigger?: React.ReactNode;
  showArrow?: boolean;
  children?: React.ReactNode;
  header?: React.ReactNode;
  body?: React.ReactNode;
  footer?: React.ReactNode;
  w?: string | { base: string; md: string };
  maxH?: string;
  bodyMaxH?: string;
  bg?: string;
  borderColor?: string;
  boxShadow?: string;
  maxW?: string;
}
const CustomPopover = React.forwardRef<HTMLDivElement, Props>(
  (
    {
      open,
      setOpen,
      placement,
      trigger,
      showArrow,
      children,
      header,
      body,
      footer,
      w,
      maxH,
      bodyMaxH,
      bg,
      borderColor,
      maxW,
    },
    ref
  ) => {
    const { scrollBar } = useStyles();
    return (
      <Popover.Root
        open={open}
        onOpenChange={(e) => setOpen?.(e.open)}
        positioning={{ placement: placement || "bottom" }}
        autoFocus={true}
        closeOnEscape
      >
        <Popover.Trigger asChild>{trigger}</Popover.Trigger>
        <Popover.Positioner>
          <Popover.Content
            w={w}
            maxW={maxW}
            maxH={maxH}
            bg={bg}
            borderColor={borderColor}
            boxShadow="xl"
            zIndex={9999}
            ref={ref}
          >
            {showArrow && <Popover.Arrow />}
            {header && (
              <Popover.Header
                borderBottom="1px"
                borderColor={borderColor}
                bg={bg}
              >
                {header}
              </Popover.Header>
            )}

            <Popover.Body maxH={bodyMaxH} overflow="auto" css={scrollBar}>
              {children || body}
            </Popover.Body>
            {footer && (
              <Popover.Footer borderTop="1px" borderColor={borderColor} bg={bg}>
                {footer}
              </Popover.Footer>
            )}
          </Popover.Content>
        </Popover.Positioner>
      </Popover.Root>
    );
  }
);

export default CustomPopover;
